/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProvinceInputs */

const th_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จังหวัด`)
};

const en_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Province`)
};

const ja_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`県`)
};

const zh_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`府`)
};

const es_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provincia`)
};

const pt_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Província`)
};

const id_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provinsi`)
};

const fr_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Province`)
};

const tl_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lalawigan`)
};

const vi_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tỉnh`)
};

const ko_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주`)
};

const de_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provinz`)
};

const ru_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Провинция`)
};

const tr_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İl`)
};

const it_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provincia`)
};

const pl_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prowincja`)
};

const uk_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Провінція`)
};

const hi_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रांत`)
};

const ar_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المحافظة`)
};

const ms_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wilayah`)
};

const bn_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রদেশ`)
};

const zh_tw2_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`府`)
};

const zh_hk2_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`府`)
};

const ur_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صوبہ`)
};

const fa_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استان`)
};

const sw_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkoa`)
};

const nl_province = /** @type {(inputs: ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provincie`)
};

/**
* | output |
* | --- |
* | "Province" |
*
* @param {ProvinceInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const province = /** @type {((inputs?: ProvinceInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProvinceInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_province(inputs)
	if (locale === "ja") return ja_province(inputs)
	if (locale === "zh") return zh_province(inputs)
	if (locale === "es") return es_province(inputs)
	if (locale === "pt") return pt_province(inputs)
	if (locale === "id") return id_province(inputs)
	if (locale === "fr") return fr_province(inputs)
	if (locale === "tl") return tl_province(inputs)
	if (locale === "vi") return vi_province(inputs)
	if (locale === "ko") return ko_province(inputs)
	if (locale === "de") return de_province(inputs)
	if (locale === "ru") return ru_province(inputs)
	if (locale === "tr") return tr_province(inputs)
	if (locale === "it") return it_province(inputs)
	if (locale === "pl") return pl_province(inputs)
	if (locale === "uk") return uk_province(inputs)
	if (locale === "hi") return hi_province(inputs)
	if (locale === "ar") return ar_province(inputs)
	if (locale === "ms") return ms_province(inputs)
	if (locale === "bn") return bn_province(inputs)
	if (locale === "zh-TW") return zh_tw2_province(inputs)
	if (locale === "zh-HK") return zh_hk2_province(inputs)
	if (locale === "ur") return ur_province(inputs)
	if (locale === "fa") return fa_province(inputs)
	if (locale === "sw") return sw_province(inputs)
	if (locale === "nl") return nl_province(inputs)
	return en_province(inputs)
});